import React, {useEffect, useState} from 'react'
import Encabezado from './Components/Encabezado'
import FormularioCierre from './Components/DatosDeCierre/FormularioCierre'
import {State} from '../../reducers'
import {LoaderRedux} from '../../components/LoaderRedux'
import { BasicLayout } from '../../modules/Layouts/basicLayout'
import {bindActionCreators} from 'redux'
import { setActiveModuleDoc } from '../../actions/documentos/documentos.actions'
import {useDispatch, useSelector} from 'react-redux'
import {actionFacturacionEmision, actionsLogin} from '../../actions/action-creators'
import { validateHorarioSucursal, validateUsoModulo } from '../../actions/general.actions'

const CierrePeriodoFiscal = () => {
  const loader = useSelector((state: State) => state.general.loader)
  const dispatch = useDispatch()
  const actions = bindActionCreators(actionFacturacionEmision, dispatch)
  const {suscripcionGetFacturasDisponibles} = bindActionCreators(actionsLogin, dispatch)
  const [loader2, setLoader2] = useState(false)

  return (
    <BasicLayout>
      {!loader && loader2 && <LoaderRedux />}
      <Encabezado url='/mas-opciones' />
      <div id='w-node-_5c6af4dc-0d52-341f-2ef6-a52695e59ec5-0b1e6fa6' className='w-layout-layout bill-section wf-layout-layout'>
        <div id='w-node-_5c6af4dc-0d52-341f-2ef6-a52695e59ed4-0b1e6fa6' className='w-layout-cell'>
          <div className='card'>
            <div className='w-layout-vflex card-content'>
              <FormularioCierre/>
            </div>
          </div>
        </div>
      </div>
    </BasicLayout>
  )
}

export default CierrePeriodoFiscal
